<form [formGroup]="editorform">
  <!--p-editor [style]="{'height':'320px'}" formControlName="test"></p-editor-->
  </form>
